import React from "react";
import { findAllTypePersonEvent } from "../../_events/type_person/find.event";
import { alertError } from "../../_utils/alerts";

export const useTypePersonAll = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllTypePersonEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}